import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型探索，发现你的下一部最爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline p-5 md:p-6 flex flex-col gap-3"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${item.color} text-background-50`}>
                <i className={`text-lg md:text-xl ${
                  i === 0 ? 'ri-fire-line' :
                  i === 1 ? 'ri-heart-line' :
                  i === 2 ? 'ri-search-eye-line' :
                  i === 3 ? 'ri-compass-3-line' :
                  i === 4 ? 'ri-emotion-laugh-line' :
                  i === 5 ? 'ri-brush-line' :
                  'ri-rocket-line'
                }`}></i>
              </div>

              <div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}